// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbNav":"index-breadcrumbNav-hVUNb","breadcrumbNavIcon":"index-breadcrumbNavIcon-1_I4H","breadcrumbNavText":"index-breadcrumbNavText-3CS7h","text2":"index-text2-2QuCh"};